import { useState } from 'react';
import type { Nullable } from 'corgi-types';

import type { ErrorMessage } from '../../types/error';

export const useTranslatedErrorMessageState = () => {
  const [errorMessage, setErrorMessage] = useState<Nullable<ErrorMessage>>(null);

  const setMessage = (message: Nullable<string>) =>
    setErrorMessage(
      message
        ? {
            message,
            timestamp: Date.now(),
            translated: true,
          }
        : null
    );

  return [errorMessage, setMessage] as const;
};
